<template>
    <div class="teacher-management-container container">
      <el-card shadow="hover">
        <template #header>
          <div class="card-header">
            <h2>إدارة حسابات المعلمين</h2>
            <el-button type="primary" @click="handleCreate">
              <el-icon><Plus /></el-icon> إضافة معلم جديد
            </el-button>
          </div>
        </template>
  
        <el-alert
          title="إدارة المعلمين"
          type="info"
          description="هذه الواجهة مخصصة لإنشاء وإدارة حسابات المستخدمين الخاصة بالمعلمين فقط."
          :closable="false"
          show-icon
          style="margin-bottom: 20px;"
        />
        
        <div class="filter-section">
          <el-input
            v-model="filters.search"
            placeholder="ابحث باسم المعلم أو اسم المستخدم..."
            @input="handleSearch"
            clearable
            style="width: 300px; margin-bottom: 20px;"
          />
        </div>
  
        <el-table :data="teachers" v-loading="loading" border style="width: 100%">
    <el-table-column prop="name" label="اسم المعلم" min-width="180" />
    <el-table-column prop="username" label="اسم المستخدم" min-width="150" />
    <el-table-column prop="phone" label="رقم الهاتف" width="150" />
    
    <el-table-column label="المقررات المسندة" width="160" align="center">
        <template #default="{ row }">
            <el-tag :type="row.teacher_course_assignments && row.teacher_course_assignments.length > 0 ? 'success' : 'info'">
                {{ row.teacher_course_assignments && row.teacher_course_assignments.length > 0 ? `(${row.teacher_course_assignments.length}) مقررات` : 'لا يوجد' }}
            </el-tag>
        </template>
    </el-table-column>
    
    <el-table-column label="الإجراءات" width="180" fixed="right" align="center">
        <template #default="{ row }">
            <el-button size="small" type="primary" @click="manageAssignments(row)">
                إدارة الإسناد
            </el-button>
        </template>
    </el-table-column>
</el-table>
        <div class="pagination-container">
          <el-pagination
            v-if="pagination.total > 0"
            @current-change="handlePageChange"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            :total="pagination.total"
            layout="total, prev, pager, next"
            background
          />
        </div>
      </el-card>
  
      <el-dialog v-model="dialogVisible" title="إنشاء حساب معلم جديد" width="50%" :close-on-click-modal="false">
        <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="اسم المعلم الكامل" prop="name">
                      <el-input v-model="form.name" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="اسم المستخدم" prop="username">
                      <el-input v-model="form.username" />
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="رقم الهاتف" prop="phone">
                      <el-input v-model="form.phone" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="البريد الإلكتروني" prop="email">
                      <el-input v-model="form.email" />
                  </el-form-item>
              </el-col>
          </el-row>
          <el-form-item label="العنوان" prop="address">
              <el-input v-model="form.address" />
          </el-form-item>
          <el-form-item label="كلمة المرور" prop="password">
            <el-input v-model="form.password" type="password" show-password />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">إلغاء</el-button>
            <el-button type="primary" @click="submitForm" :loading="formLoading">إنشاء الحساب</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { Plus } from '@element-plus/icons-vue';
  import debounce from 'lodash/debounce';
  
  export default {
    name: 'TeacherManagement',
    components: { Plus },
    data() {
      return {
        api: null,
        loading: true,
        teachers: [],
        filters: { search: '' },
        pagination: { current_page: 1, per_page: 15, total: 0 },
        
        dialogVisible: false,
        formLoading: false,
        form: this.getInitialForm(),
        rules: {
          name: [{ required: true, message: 'اسم المعلم مطلوب', trigger: 'blur' }],
          username: [{ required: true, message: 'اسم المستخدم مطلوب', trigger: 'blur' }],
          phone: [{ required: true, message: 'رقم الهاتف مطلوب', trigger: 'blur' }],
          address: [{ required: true, message: 'العنوان مطلوب', trigger: 'blur' }],
          password: [{ required: true, min: 8, message: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل', trigger: 'blur' }],
        }
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use((config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
      this.fetchTeachers();
    },
    methods: {

        // ... داخل methods في ملف TeacherManagement.vue
// ... داخل methods في ملف TeacherManagement.vue
manageAssignments(teacher) {
  // ✨ التغيير هنا: قمنا بتغيير teacherId إلى user ✨
  this.$router.push({ name: 'TeacherAssignments', params: { user: teacher.id } });
},
        
      getInitialForm() {
        return { 
          name: '', 
          username: '', 
          email: '', 
          phone: '',
          address: '',
          password: '', 
          user_type: 'teacher' // قيمة ثابتة لإنشاء المعلمين
        };
      },
      async fetchTeachers() {
        this.loading = true;
        try {
          const params = { 
              ...this.filters, 
              page: this.pagination.current_page, 
              per_page: this.pagination.per_page,
              user_type: 'teacher' // فلترة لجلب المعلمين فقط
          };
          const response = await this.api.get('/users-teacher', { params });
          this.teachers = response.data.data;
          this.pagination.total = response.data.total;
          this.pagination.current_page = response.data.current_page;
        } catch (error) {
          ElMessage.error('فشل في جلب بيانات المعلمين.');
        } finally {
          this.loading = false;
        }
      },
      handleSearch: debounce(function() {
        this.pagination.current_page = 1;
        this.fetchTeachers();
      }, 500),
      handlePageChange(page) {
        this.pagination.current_page = page;
        this.fetchTeachers();
      },
      handleCreate() {
          this.$refs.formRef?.resetFields();
          this.form = this.getInitialForm();
          this.dialogVisible = true;
      },
      async submitForm() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) return;
  
          this.formLoading = true;
          try {
            await this.api.post('/users-teacher', this.form);
            ElMessage.success('تم إنشاء حساب المعلم بنجاح!');
            this.dialogVisible = false;
            this.fetchTeachers();
          } catch (error) {
            const errorMsg = error.response?.data?.message || 'فشل في إنشاء الحساب.';
            ElMessage.error(errorMsg);
          } finally {
            this.formLoading = false;
          }
        });
      },
    },
  };
  </script>